import React, { useState, useEffect } from 'react';
import PhoneInput, {CountryData } from 'react-phone-input-2';
import { FormControl } from '@mui/material';
/* import getPhoneNumberLocale from 'core/locales/getPhoneNumberLocale'; */
import 'react-phone-input-2/lib/material.css';
import './styles.css';

interface PhoneNumberProps {
  setFormError?: (error: string | undefined) => void;
  onFieldChange?: (value: string, countryCode: string) => void;
  input: {
    value: string | null;
    onChange: (value: string | null, countryCode?: string) => void;
  };
  meta: {
    touched: boolean;
  };
  initialError?: string | undefined;
  localizate: object;
  initialCountry?: string;
  label?: string;
  className?: string;
  style?: React.CSSProperties;
  errorMessage?: string;
}

const PhoneNumber: React.FC<PhoneNumberProps> = ({
  setFormError = () => {},
  onFieldChange = () => {},
  input,
  meta,
  initialError,
  localizate,
  initialCountry = 'us',
  label,
  className,
  style,
  errorMessage,
}) => {
  const [hasError, setHasError] = useState<string | undefined>(initialError);
  const [value, setValue] = useState<string | undefined>(input.value || undefined);



  
function validatePhoneNumberE164(phone: string): boolean {
  // E.164 format: starts with + followed by up to 15 digits
  const regex = /^\+?[1-9]\d{1,14}$/;
  return regex.test(phone);
}

  

  useEffect(() => {
    setHasError(initialError);
  }, [initialError]);

  return (
    <FormControl className={className}>
      <style>
        {`.react-tel-input .special-label {
          color: ${hasError ? '#f44336' : 'black'};
        }
        .react-tel-input .form-control:hover {
          border-color: ${hasError ? '#f44336' : 'black'};
          cursor: default;
        }
        .react-tel-input .form-control:focus {
          border-color: ${hasError ? '#f44336' : '#333'};
        }
        .react-tel-input .form-control {
          border: 1px solid ${hasError ? '#f44336' : '#cacaca'};
        }
        .MuiFormHelperText-root.Mui-error {
          color: #f44336;
        }
        .MuiFormHelperText-contained {
          margin: 2px 0 0 2px;
          margin-left: 14px;
          margin-right: 14px;
        }
        .MuiFormHelperText-root {
          font-size: 12px;
          font-style: italic;
          font-family: Open sans, sans-serif;
          font-weight: 400;
          line-height: 22px;
        }`}
      </style>
      <PhoneInput
        country={initialCountry}
        placeholder=""
        value={input.value || ''}
        onChange={(value: string, country: CountryData) => {
          const formattedValue = `+${value}`;
          const error = validatePhoneNumberE164(formattedValue) ? undefined : 'Invalid phone number format (must be in E.164)';          setHasError(error);
          setFormError(error);
          onFieldChange(`+${value}`, country.countryCode);
          input?.onChange(value ? `+${value}` : null, country.countryCode);
        }}
        localization= {localizate}/* {getPhoneNumberLocale()}  VOLVER A PONER ESTO*/
        specialLabel={label}
      />
      {(hasError || (!value && meta.touched)) && (
        <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error Mui-required">
          {errorMessage}
        </p>
      )}
    </FormControl>
  );
};

export default PhoneNumber;
